import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);
export function videoBoxAnimations() {
    document.addEventListener('DOMContentLoaded', () => {

        // Animazione di entrata al momento dello scroll
        gsap.from(".video-wrapper", {
            scrollTrigger: {
                trigger: ".video-wrapper",
                start: "top 80%", // inizia quando l'elemento entra all'80% dell'altezza viewport
                toggleActions: "play none none none"
            },
            y: 50,
            opacity: 0,
            duration: 0.8,
            ease: "power2.out"
        });+

        gsap.from('.video-box__title', {
            scrollTrigger: {
                trigger: '.video-box__title',
                start: "top 80%",
                toggleActions: "play none none none"
            },
            y: 50,
            opacity: 0,
            duration: 2,
            ease: "power3.out"
        });

        document.querySelectorAll('.video-wrapper').forEach(wrapper => {
            const btn = wrapper.querySelector('.video-play-btn');
            const overlay = wrapper.querySelector('.video-overlay');
            const container = wrapper.querySelector('.video-container');

            btn?.addEventListener('click', () => {
                gsap.to(overlay, { 
                    opacity: 0, 
                    duration: 0.5, 
                    ease: "power1.out",
                    onComplete: () => overlay.remove()
                });

                const poster = container.querySelector('.video-poster');
                if (poster) {
                    gsap.to(poster, { 
                        opacity: 0, 
                        duration: 0.5, 
                        ease: "power1.out",
                        onComplete: () => poster.remove()
                    });
                }

                // Inserimento del video
                if (wrapper.dataset.videoType === 'youtube') {
                    const videoId = wrapper.dataset.videoId;
                    container.innerHTML = `
                        <iframe src="https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0"
                                frameborder="0"
                                allow="autoplay; encrypted-media"
                                allowfullscreen></iframe>
                    `;
                } 
                else if (wrapper.dataset.videoType === 'mp4') {
                    const mp4Src = wrapper.dataset.mp4Src;
                    container.innerHTML = `
                        <video controls autoplay>
                            <source src="${mp4Src}" type="video/mp4">
                            Il tuo browser non supporta il video.
                        </video>
                    `;
                }

                // Fade-in del video appena caricato
                gsap.from(container.querySelector('iframe, video'), {
                    opacity: 0,
                    scale: 0.95,
                    duration: 0.6,
                    ease: "power2.out"
                });
            });
        });
    });
}